var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_40_38)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#1A1A1A",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58,
    height: 58,
    rx: 29,
    stroke: "#333333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9524 37C24.3651 37 24 36.5286 24 35.8092V24.1825C24 23.4631 24.3651 23 24.9524 23C25.2698 23 25.5397 23.124 25.8571 23.3142L35.1111 28.896C35.7698 29.293 36 29.5576 36 29.9959C36 30.4341 35.7698 30.6988 35.1111 31.104L25.8571 36.6775C25.5397 36.8677 25.2698 37 24.9524 37Z",
    fill: "white",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_40_38",
    x: -6,
    y: -6,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_40_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_40_38",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySvg);
export default __webpack_public_path__ + "static/media/Play SVG.57bac370db8faf8128525053dd5e981e.svg";
export { ForwardRef as ReactComponent };